import {Assertion} from '@udemy/badging';
import {UDDataMe} from '@udemy/ud-data';

export const isUserAssertionOwner = (loggedInUser: UDDataMe, assertion: Assertion): boolean => {
    return loggedInUser.is_authenticated && loggedInUser.id === parseInt(assertion.user.id, 10);
};
